export default __webpack_public_path__ + "static/media/10-small.e0819967.png";